import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Stack, Title } from "@mantine/core";
import { Edit } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { ImageWithPlaceholder } from "./ImageWithPlaceholder";
export const ProfileCard = ({ drawerInfo, onClickEdit, options: { showAvatar = true, showTitle = true, profileSize = 150, titleComponent, subTitleComponent, allowEdit = false } = {} }) => {
    const info = drawerInfo && typeof drawerInfo === "object"
        ? drawerInfo
        : null;
    let name = null;
    if (info && "name" in info) {
        name = String(info?.name ?? "");
    }
    else if (info && "first_name" in info && "last_name" in info) {
        name = `${String(info.first_name ?? "")} ${String(info.last_name ?? "")}`.trim();
    }
    else if (info && "firstName" in info && "lastName" in info) {
        name = `${String(info.firstName ?? "")} ${String(info.lastName ?? "")}`.trim();
    }
    const imageUrl = info && "imageUrl" in info ? info.imageUrl : undefined;
    return (_jsxs(Stack, { style: {
            padding: "1rem",
            paddingBottom: 0,
            boxShadow: "0 0 10px color-mix(in srgb, var(--mantine-color-black) 10%, transparent)",
            borderRadius: "0.65rem"
        }, children: [allowEdit && onClickEdit && (_jsx(ActionIcon, { variant: "subtle", ml: "auto", onClick: () => {
                    onClickEdit();
                }, children: _jsx(SvgIcon, { component: Edit, style: { color: "var(--mantine-color-primary-9)" } }) })), _jsxs(Stack, { gap: "xs", style: {
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "1rem"
                }, children: [showAvatar && (_jsx(ImageWithPlaceholder, { imageUrl: imageUrl, avatarText: name, size: profileSize })), titleComponent, subTitleComponent, showTitle && (_jsx(Title, { order: 4, style: {
                            cursor: "pointer",
                            textAlign: "center",
                            wordWrap: "break-word",
                            whiteSpace: "normal"
                        }, children: name }))] })] }));
};
